import { clsx } from 'clsx';
import { FC } from 'react';

type Props = {
  className?: string;
  'data-testid'?: string;
};

export const CircularProgress: FC<Props> = ({ className, ...props }) => (
  <div {...props} className={clsx(className, 'CircularProgress')} role="progressbar" data-testid="loading-icon">
    <svg className="CircularProgress-icon" aria-hidden="true" viewBox="22 22 44 44" name="circular-progress">
      <circle className="CircularProgress-circle" cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6" />
    </svg>
  </div>
);
